import fs from 'node:fs'

export function cleanCss(cssPath: string, namespace = 'admin'): string[] {
  if (!fs.existsSync(cssPath)) return []

  const content = fs.readFileSync(cssPath, 'utf-8')
  const lines = content.split('\n')

  const sourcePattern = new RegExp(`^@source\\s+"[^"]*(?:admin|${namespace})[^"]*";\\s*$`)
  const removed: string[] = []
  const kept: string[] = []

  for (const line of lines) {
    if (sourcePattern.test(line)) {
      removed.push(line.trim())
    } else {
      kept.push(line)
    }
  }

  if (removed.length === 0) return []

  const cleaned = kept.join('\n').replace(/\n{3,}/g, '\n\n')
  fs.writeFileSync(cssPath, cleaned, 'utf-8')
  return removed
}
